export const SIDEMENU = "SIDEMENU";
export const UPDATE_ALL = "UPDATE_ALL";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
export const USER_ROLE_ID = "USER_ROLE_ID";
export const DEVICE_STATUS = "DEVICE_STATUS";
